/** @format */

export const featureFlagNames = [
    'BEAK-2867-(model-recommendations)',
    'BOO-3170-(sell-balance)',
    'LOVE-747-(enhanced-product-protection)',
    'BEAK-3098-(auto-out-of-stock-search)',
    'BEAK-3676-(usp-tags)',
    'APE-2838-(self-serve-returns-phase-2)',
    'TUR-3230-(super-skus)',
    'LOVE-1153-(sell-journey-accessories-checklist)',
    'TUR-3337-(nlx-beta)',
    'APE-3416-(buy-transaction-progress-tracker)',
    'TUR-3223-(semantic-search-endpoint)',
    'BOO-3485-(vat-registered-buy)',
    'IAM-7-(anonymous-user)',
    'LOVE-1461-(basket-MPBX-bridge)',
    'TUR-3496-(nl-search)',
] as const;

export enum RecommendationsVariant {
    CONTROL = 'control',
    VARIANT = 'variant',
}

export enum BasketBridgeHeaderValue {
    ON = 'on',
    OFF = 'off',
}

export const ANONYMOUS_USER = 'IAM-7-(anonymous-user)' as const;

export const BASKET_MPBX_BRIDGE_FEATURE_FLAG =
    'LOVE-1461-(basket-MPBX-bridge)' as const;
